import { fixedUi, fixedUiTpl } from '@/i18n/fixedUi';
import React, { useEffect, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import { showToast } from '@/utils/toast';
import { parseBatchTokens, BATCH_QUERY_LIMIT } from './batchQueryUtils';

/**
 * 批量查询弹窗：换行或逗号分隔，上限 500 条
 */
export default function BatchQueryModal({
  open,
  title = fixedUi("批量查询"),
  initialValue = '',
  placeholder = fixedUi('每行一条，或用逗号分隔；最多 500 条'),
  onConfirm,
  onClose,
}) {
  const [text, setText] = useState('');

  useEffect(() => {
    if (!open) return;
    const tokens = parseBatchTokens(initialValue);
    setText(tokens.length ? tokens.join('\n') : '');
  }, [open, initialValue]);

  const tokens = useMemo(() => parseBatchTokens(text), [text]);
  const count = tokens.length;
  const overLimit = count > BATCH_QUERY_LIMIT;

  if (!open) return null;

  const handleConfirm = () => {
    const next = tokens.slice(0, BATCH_QUERY_LIMIT);
    if (overLimit) {
      showToast(fixedUiTpl('已按上限保留前 {0} 条', BATCH_QUERY_LIMIT), 'info');
    }
    onConfirm?.(next);
    onClose?.();
  };

  return createPortal(
    <div className="tko-batch-modal tko-batch-modal--no-backdrop-close" role="presentation">
      <div className="tko-batch-modal__backdrop" aria-hidden="true" />
      <div
        className="tko-batch-modal__panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="tko-batch-modal-title"
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="tko-batch-modal__head">
          <h2 id="tko-batch-modal-title">{title}</h2>
          <button type="button" className="tko-btn tko-btn--ghost tko-btn--sm" onClick={onClose}>
            {fixedUi("关闭")}
          </button>
        </div>
        <div className="tko-batch-modal__body">
          <div className="tko-batch-modal__meta">
            <p className="tko-batch-modal__hint">
              {fixedUiTpl('支持换行或逗号分隔，单次最多查询 {0} 条', BATCH_QUERY_LIMIT)}
            </p>
            <span className={`tko-batch-modal__count${overLimit ? ' tko-batch-modal__count--warn' : ''}`}>
              {fixedUiTpl('已输入 {0} / {1}', count, BATCH_QUERY_LIMIT)}
              {overLimit ? fixedUi('（超出将截断）') : ''}
            </span>
          </div>
          <textarea
            className="tko-textarea tko-batch-modal__textarea"
            value={text}
            placeholder={placeholder}
            onChange={(e) => setText(e.target.value)}
            rows={14}
            autoFocus
          />
        </div>
        <div className="tko-batch-modal__foot">
          <button type="button" className="tko-btn tko-btn--secondary tko-btn--sm" onClick={onClose}>
            {fixedUi("取消")}
          </button>
          <button type="button" className="tko-btn tko-btn--primary tko-btn--sm" onClick={handleConfirm}>
            {fixedUi('确认')}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
